import { buildCollectionPageJsonLd, buildItemListJsonLd } from "@/lib/shared/seo";
import type { MediaDisplay } from "@/lib/shared/types/interfaces";

type StructuredGiftSet = {
  slug: string;
  displayTitle: string;
  image?: MediaDisplay | null;
  coverImage?: MediaDisplay | null;
};

interface GiftSetCollectionStructuredDataProps {
  locale: string;
  title: string;
  description?: string;
  giftSets: StructuredGiftSet[];
}

export function GiftSetCollectionStructuredData({
  locale,
  title,
  description,
  giftSets,
}: GiftSetCollectionStructuredDataProps) {
  const collectionJsonLd = buildCollectionPageJsonLd({
    locale,
    pathname: "/gift-sets",
    title,
    description,
  });
  const itemListJsonLd = buildItemListJsonLd(
    locale,
    giftSets.map((giftSet) => ({
      name: giftSet.displayTitle,
      pathname: `/gift-sets/${giftSet.slug}`,
      image: (giftSet.image ?? giftSet.coverImage)?.src,
    })),
  );

  return (
    <>
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(collectionJsonLd) }}
      />
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(itemListJsonLd) }}
      />
    </>
  );
}
